import React from 'react';
import PropTypes from 'prop-types';

const ShareAndroid = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12.651 14"
    className={className}
  >
    <path
      d="M13.542,11.9a2.047,2.047,0,0,0-1.378.541L7.154,9.52a2.3,2.3,0,0,0,.063-.492,2.3,2.3,0,0,0-.063-.492l4.955-2.889a2.1,2.1,0,1,0-.675-1.539A2.3,2.3,0,0,0,11.5,4.6L6.542,7.489a2.108,2.108,0,1,0,0,3.078l5,2.924a1.983,1.983,0,0,0-.056.457A2.052,2.052,0,1,0,13.542,11.9Z"
      transform="translate(-3 -2)"
      fill={fill}
    />
  </svg>
);

ShareAndroid.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ShareAndroid;
